import React, { Component } from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import Img from "gatsby-image";
import { Helmet } from "react-helmet";
import Youtube from "../img/icon/youtube.inline.svg";
import Spotify from "../img/icon/spotify.inline.svg";
import ApplePodCasts from "../img/icon/apple-podcasts.inline.svg";
import PlaySermon from "../img/icon/play.inline.svg";
import SermonsSlider from "../components/sermons-slider";
import OurCommitment from "../components/our-commitment";
import FindUsOn from "../components/find-us-on";
import { OutboundLink } from "gatsby-plugin-google-analytics";
import AniLink from "gatsby-plugin-transition-link/AniLink";
import YouTube from '@u-wave/react-youtube';

export default class Sermons extends Component {
  constructor(props) {
    super(props);
  }

  openModal() {
    this.setState({ isOpen: true });
  }

  componentDidMount() {
    // anime({
    //   targets: ".sermon-title",
    //   opacity: 1,
    //   easing: "cubicBezier(0.115, 0.61, 0.255, 1)",
    //   duration: 3000,
    //   top: 40,
    //   delay: anime.stagger(100, { start: 1000 }),
    // });
  }

  render() {
    const { data } = this.props;
    const allSermons = data?.allContentfulSermon?.nodes;
    const featured = allSermons[0];
    const sermons = allSermons;
    return (
      <Layout>
        <Helmet>
          <title>Sermons - Gracehouse Church Logan</title>
          <meta
            property="og:title"
            content="Sermons - Gracehouse Church Logan"
          />
          <meta name="description" content="Holiness is a love affair" />
          <meta property="og:description" content="Holiness is a love affair" />
          <meta
            property="og:image"
            content={data.headerImage2.childImageSharp.fluid.src}
          />
        </Helmet>
        <section className="sermons-header">
          <div className="container sermons-hero">
            <div className="sermons-hero-social">
              <ul>
                <li>
                  <OutboundLink
                    onMouseEnter={this.onHoverLink}
                    onMouseLeave={this.onLeaveLink}
                    target="_blank"
                    href={data.site.siteMetadata.youtubeUrl}
                  >
                    <Youtube />
                    <span>Youtube</span>
                  </OutboundLink>
                </li>
                <li>
                  <OutboundLink
                    target="_blank"
                    onMouseEnter={this.onHoverLink}
                    onMouseLeave={this.onLeaveLink}
                    href={data.site.siteMetadata.spotifyPodcastUrl}
                  >
                    <Spotify />
                    <span>Spotify</span>
                  </OutboundLink>
                </li>
                <li>
                  <OutboundLink
                    target="_blank"
                    onMouseEnter={this.onHoverLink}
                    onMouseLeave={this.onLeaveLink}
                    href={data.site.siteMetadata.applePodcastUrl}
                  >
                    <ApplePodCasts />
                    <span>Apple Podcasts</span>
                  </OutboundLink>
                </li>
              </ul>
            </div>
            <div className="sermons-hero-title">
              <h1>
                Our <span>Sermons</span>
              </h1>
            </div>
          </div>
        </section>

        <section className="sermons-middle-hero">
          <div className="hero-background-wrapper">
            <YouTube
              video={featured.youtubeEmbedId}
              className="background-video"
              overlay={"rgba(0,0,0,0.3)"}
            // autoplay={true}
            // controls={false}
            // paused={false}
            >
              {/* <div className="sermon-title container">
                  <h2>
                    {featured.title}
                  </h2>
                  <p>{featured.reference}</p>

                  <button>
                    <PlaySermon /> <span> Play Sermon</span>
                  </button>
                </div> */}
            </YouTube>
            <AniLink fade to={`/sermons/${featured?.slug}`}>
            </AniLink>
          </div>
        </section>
        <section>
          <SermonsSlider data={sermons} isSermons />
        </section>
        <section className="container">
          <OurCommitment />
        </section>
        <section>
          <FindUsOn />
        </section>
      </Layout>
    );
  }
}
export const pageQuery = graphql`
  query SermonsQuery {
    site {
      siteMetadata {
        title
        youtubeUrl
        spotifyPodcastUrl
        applePodcastUrl
      }
    }
    headerImage2: file(relativePath: { eq: "church.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    allContentfulSermon(sort: { fields: date, order: DESC }) {
      nodes {
        date
        id
        slug
        title
        reference
        youtubeEmbedId

        description {
          json
        }
        slug
      }
    }
  }
`;
